module.exports = __webpack_public_path__ + "0ade11b9aa90d32b268e4ddf8fed9078.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/fotl-3931-white.jpg
// module id = 829
// module chunks = 0